<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { store } from './store';

export default defineComponent({
  name: "App",
  components: {},
  created() {
    store.dispatch("startup");
  },
  methods: {},
  computed: {}
})
</script>